import { useState, useEffect, useLayoutEffect, use } from 'react'
import { useSearchParams } from 'react-router-dom';
import '../Managing/Managing.css'
import './Memorizing.css'
import {setting} from '../Config/ar'
import {ToNotify} from '../Shared/ViewControl'
import MemorizeControl from './MemorizeControl'
import {Get, Cookie} from '../Api'
import {Duration} from '../Shared/Formating'
import {onGet} from '../Shared/Akademy'
import TreeView from "../meTree/TreeView"
import Activities from '../Shared/Activities'
import {meSplitter} from '../Shared/meLayout'

import { useApp } from "../../context/AppContext";

const Memorizing = ({search, onEtat, role, course, layout}) => {
    const entity='Memorizing';

    const { setActivity, setElement } = useApp();

    // MeR 260421 akademy.ma/bot needed !
    const [searchParams] = useSearchParams();
    const [wajh, Wajh] = useState(Number(searchParams.get('wajh')) || 0); // searchParams.get() retourne toujours une String

    const [page, Page] = useState(0)
    const [note, Note] = useState(0)
    const [reported, Reported] = useState(6)
    const [message, Message] = useState('')
    const [status, Status] = useState(0)
    const [items , Items] = useState([])

    const [item, Item]= useState({Element:1, Course:course, Focused:29})

    const [selected, Select] = useState(false)
    const [safahaat , Safahaat] = useState([])

    const version = parseInt(Cookie('meVersion') ?? '1')

    const splitter = new meSplitter(`${entity}Side`,`${entity}Container`,layout)
    useLayoutEffect (()=>{  
        splitter.selectorAll() 
    })

    useEffect(()=>{
        if(wajh>0) {
            //alert(`${wajh} ${course}`)
            Page(wajh)
        }
    },[wajh])

    useEffect(()=>{
        if(page>0) {
            setElement(page)
            setActivity(4)
            document.cookie = `meSafha=${page}`
            //alert(page)
        }
    },[page])

    useEffect(() => {
        //alert(`Course ${course} items ${items.length} ${wajh}`)
        if(items.length===0) {
            Get(entity+"/Safha", Items, null, Message, Status)

            if([200,202].includes(status)) { 
                sessionStorage.setItem("routeCurrent","/memorizing")
            }
            else if(status===204) {
                Message(setting.course.unaccepted)
            }      
        }
        else {
            let current=course>1?course:items[0].Course
            Item({...items[0], Course:current})

            //alert(`current ${current} version ${version}`)
            if(version===1)
                onGet(`/waqafaat/Memorizing&${current}`, Safahaat, Select)
            else if(version===2)
                onGet(`/hafs/Memorizing&${current}`, Safahaat, Select)
             
        }    

    }, [status])

    useEffect(() => {
        if(safahaat.length>0) { 
            let i = safahaat.findIndex(s=>s.Safha===item.Element)
            let value = safahaat[0].Safha
            if(i>0) { 
                value = item.Element                
            }
            else {
                let safha = parseInt(Cookie('meSafha') ?? '0')

                if(safha>value && safha<=safahaat[safahaat.length-1].Safha) {
                    value = safha
                    Item({...item, Element:safha})
                }
            }

            if(wajh>0)
                value=wajh

            //  alert(`Course ${item.Course} ${value}`)
            onEtat(`${Duration(item.Focused)} - صفحة ${value}`)

            onPage(value)
        }
    }, [selected])

    const onNote = (id) => {
        Note(id)
    }
    
    const onPrev = () => {
        let min = Math.min(...safahaat.map(item => (item.Safha??0)));
        if(min<1) 
            min=1;
        //alert(`${page} -> ${min}`)
        if(page>min)
        {
            onPage(page-1)
        }
    }

    const onNext =() => {
        const max = Math.max(...safahaat.map(item => item.Safha??0));
        //alert(`${page} -> ${max}`)
        if(page<max)
        {
            onPage(page+1)
        }
    }

    const onNode = (e, levels) => {
        if(levels[3]>0 && page!==levels[3]) {
            Page(levels[3])
        }
    }

    const onPage = (safha) => {
        Page(safha)
    }

    useEffect(()=>{
        onEtat(message)
    },[message])


return (

(page===0 || !selected) ? 
    <div className="Loading Error">{message}</div> 
:
(
layout ? 
    <div className="Sides" id={`${entity}Container`} 
        onMouseDown={(e)=>{splitter.mouseDown(e)}} 
        onMouseMove={(e)=>{splitter.mouseMove(e)}} 
        onMouseUp={(e)=>{splitter.mouseUp(e)}}
    >
    <div className="side vside" id={`${entity}SideActivities`} style={{width: '25%'}}>
        <Activities activity={4} element={page} onElement={onNote} reported={reported} search={search} />
    </div>

    <div className="side vside" id={`${entity}SideReadControl`} style={{width: '50%', overflow: 'hidden'}}>
        <MemorizeControl role={role} version={version} page={page} onNext={onNext} onPrev={onPrev} onPage={onPage} pages={safahaat} onEtat={onEtat} Message={Message} expand={wajh>0} />
    </div>
    <div className="side vside" id={`${entity}SideParts`} style={{width: '25%'}}>
        <TreeView onChange={onNode} page={page} course={item.Course} />
    </div>
    
    <ToNotify message={message} onClose={()=>Message('')} />
    </div>
: 
<MemorizeControl role={role} version={version} page={page} onNext={onNext} onPrev={onPrev} onPage={onPage} pages={safahaat} Message={Message} expand={wajh>0} />
)

     )
}

export default Memorizing

/*
    <div className="side vside" id={`${entity}SideTimers`} style={{width: '20%'}}>
        <Timers element={page} onElement={onPage} reported={reported}/>
    </div>

 */